import React, {useEffect} from 'react';
import {Header} from 'components';
import css from './hero.scss';

export function HeroYuval(props) {
  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://platform.linkedin.com/badges/js/profile.js';
    script.async = true;
    script.defer = true;
    document.body.appendChild(script);
    return () => document.body.removeChild(script);
  }, []);
  return (
    <div className={css.heroGw}>
      {props.refHeaderBreakpoint &&
        <Header.Compensate ref={props.refHeaderBreakpoint} className={css.compensate} />
      }
      <div className={css.container}>
        <h5>A former hi-tech executive that became a “life engineer” and an Executive Leadership Coach.</h5>
        <p><a className="link" href="https://executivecoach1.com/" target="_blank">Yuval Goren</a> is an Executive / Business Coach and the founder and CEO of Success Wizard, Inc., a company he founded with the goal of helping million people worldwide live happier, more authentic and fulfilling lives. Success Wizard develops impactful and highly effective interactive online programs and mobile applications to help people change, grow and enrich their personal and professional lives.</p>
        <p>Our innovative platform provides a complete and structured personal development programs and a set of interactive tools that educate, guide and support users looking for more clarity, meaning and prosperity in their life, and people trying to enhance and advance their careers, relationships, health and finances.</p>
        <p>These unique life-changing programs integrate the world’s most effective personal development and coaching techniques to provide a complete step-by-step practical and affordable solution to support users in achieving their personal goals and aspirations.</p>
        <p>Prior to founding Success Wizard, Yuval enjoyed a very successful and rewarding two-decade-long career as an entrepreneurial executive in the hi-tech industry. He made a career transition when he felt it was time to re-define his life purpose, follow his passion and pursue his dream.</p>
        <p className="badge-base LI-profile-badge" data-locale="en_US" data-size="medium" data-theme="light" data-type="VERTICAL" data-vanity="yuvalgoren" data-version="v1">
          <a className="badge-base__link LI-simple-link" href="https://www.linkedin.com/in/yuvalgoren?trk=profile-badge" />
        </p>
        <img className={css.image} src={require('./yuval-portrait.jpg')} />
        <h3><a href="https://executivecoach1.com/" target="_blank">Yuval Goren</a></h3>
        CEO, Success Wizard Inc.
      </div>
    </div>
  );
}

export function HeroSW(props) {
  return (
    <div className={css.heroSw}>
      <div className={css.container}>
        <Header.Compensate ref={props.refHeaderBreakpoint} />
        <h1>About Us</h1>
        <p>Success Wizard develops empowering and highly effective interactive online programs and mobile applications to help people change, grow and enrich their personal and professional lives.</p>
        <p>Our innovative platform delivers complete and structured personal development programs and a set of interactive tools that educate, guide and support users that are looking for more clarity, meaning and prosperity in their life, and people trying to enhance and advance their careers, relationships, health and finances.</p>
        <p>These unique life-changing programs integrate the world’s most effective personal development and coaching techniques to provide a complete step-by-step practical and affordable solution to support users in achieving their personal goals and aspirations.</p>
      </div>
    </div>
  );
}
